import { Modal, Button, Input, Typography, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useMainContext } from '../../hooks/useMainContext';
import { TbX, TbArrowsMove } from 'react-icons/tb';
import Draggable from 'react-draggable';
import CustomInput from '../Globle/CustomInput';

export const ClosetForm = observer(() => {
    const { closetManager, viewManager } = useMainContext();
    const selectedCloset = closetManager.selectedCloset;

    const [newClosetName, setNewClosetName] = useState('');
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (viewManager.closetForm) {
            setModalPosition({ x: 0, y: 0 });
        }
    }, [viewManager.closetForm]);

    useEffect(() => {
        if (selectedCloset) {
            setNewClosetName(selectedCloset.name || '');
        } else {
            setNewClosetName('');
        }
    }, [selectedCloset]);

    const saveChanges = () => {
        if (!selectedCloset) {
            message.error('No closet selected.');
            viewManager.setClosetForm(false);
            return;
        }

        if (!newClosetName.trim()) {
            message.warning('Closet name cannot be empty.');
            return;
        }

        if (newClosetName === selectedCloset.name) {
            message.info('No changes made.');
            closetManager.setSelectedCloset(null);
            viewManager.setClosetForm(false);
            return;
        }

        if (
            newClosetName !== selectedCloset.name &&
            closetManager.closets.some(
                (c) =>
                    c.name === newClosetName &&
                    (c.unitId === selectedCloset.unitId ||
                        closetManager.unitNameById(c.unitId) ===
                            closetManager.unitNameById(selectedCloset.unitId)),
            )
        ) {
            message.error('A closet with this name already exists.');
            return;
        }

        closetManager.updateClosetNameById(selectedCloset.id, newClosetName);
        message.success('Closet updated successfully.');
        viewManager.setClosetForm(false);
    };

    const closeModal = () => {
        setNewClosetName(selectedCloset?.name || '');
        viewManager.setClosetForm(false);
        closetManager.setSelectedCloset(null);
    };

    return (
        <Modal
            className="closet-form-modal"
            width={500}
            closable={false}
            footer={null}
            centered
            styles={{
                content: {
                    padding: '32px',
                    borderRadius: '32px',
                },
            }}
            open={viewManager.closetForm}
            onCancel={closeModal}
            modalRender={(modal) => (
                <Draggable
                    handle=".drag-button"
                    cancel=".ant-input, .ant-btn:not(.drag-button)"
                    onStop={(_, data) => {
                        setModalPosition({ x: data.x, y: data.y });
                    }}
                    position={modalPosition}>
                    <div>{modal}</div>
                </Draggable>
            )}>
            <div
                className="border-b-[1px] border-theme-border pb-2"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                }}>
                <Typography.Title
                    level={4}
                    style={{
                        margin: 0,
                        fontSize: '32px',
                        lineHeight: '40px',
                        color: '#000000',
                    }}>
                    Edit Closet
                </Typography.Title>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                        className="drag-button flex items-center justify-center p-0 w-[32px] h-[32px]"
                        style={{ cursor: 'move', border: 'none' }}>
                        <TbArrowsMove size={20} />{' '}
                    </Button>
                    <Button
                        type="text"
                        className="flex items-center justify-center p-0 w-[32px] h-[32px]"
                        onClick={closeModal}>
                        <TbX size={20} />
                    </Button>
                </div>
            </div>

            {selectedCloset ? (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 15,
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        }}>
                        <Typography.Text className="custom-label">
                            Closet Name:
                        </Typography.Text>
                        <CustomInput
                            value={newClosetName}
                            onChange={(e) => {
                                const value = e.target.value;
                                const regex =
                                    /^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{0,24}$/;
                                if (regex.test(value)) {
                                    setNewClosetName(value);
                                }
                            }}
                            maxLength={24}
                        />
                    </div>
                </div>
            ) : (
                <Typography.Text type="secondary">
                    No closet selected.
                </Typography.Text>
            )}

            <div
                style={{
                    marginTop: 20,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 10,
                }}>
                <Button
                    type="primary"
                    className="bg-theme-orange text-theme-white !rounded-[36px] text-[16px] w-[140px] h-[40px] !!hover:bg-theme-orange-hover !shadow-none save-changes-button"
                    onClick={saveChanges}>
                    Confirm
                </Button>
                {/* <Button
                    onClick={closeModal}
                    variant="primary"
                    className="bg-theme-button-bg close-button">
                    Close
                </Button> */}
            </div>
        </Modal>
    );
});
